import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Analytics } from '@vercel/analytics/react';

// styles
import globalStyles from '../app/styles/globalStyles';
import '@/styles/globals.scss';

// components
import MetaHeader from '@/components/Document/MetaHeader';
import Portals from '@/components/Document/Portals';

// redux
import { Provider } from 'react-redux';
import store from '@/store/store';

// context
import { IntlProviderWrapper } from '@/contexts/intlContext';

// analytics
import * as $segment from '@/utils/segment';
import {useAffiliationQuery} from "../app/hooks/useAffiliationQuery";

globalStyles();

const FinaryApp = ({ Component, pageProps, err }) => {
  const router = useRouter();
  const { locale, pathname, asPath } = router;
  const [history, setHistory] = useState([]);
  const userLocale = pageProps?.user ? pageProps?.user?.ui_configuration?.display_language : locale;
  useAffiliationQuery()

  // init Segment on mount
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      const pageCagegory =
        asPath.includes('legal') || asPath.includes('terms') || asPath.includes('privacy')
          ? 'WEBSITE'
          : pathname === '/[...strapi]'
          ? 'SEO'
          : 'WEBSITE';
      $segment.init(pageCagegory);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      const pageCagegory =
        asPath.includes('legal') || asPath.includes('terms') || asPath.includes('privacy')
          ? 'WEBSITE'
          : pathname === '/[...strapi]'
          ? 'SEO'
          : 'WEBSITE';
      $segment.page(pageCagegory);
    }
  }, [pathname, asPath]);

  // trigger event on route change
  useEffect(() => {
    const handleRouteChange = (url) => {
      setHistory((previousState) => [...previousState, url]);
    };

    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events, history]);

  return (
    <Provider store={store}>
      <IntlProviderWrapper locale={userLocale}>
        <MetaHeader />
        <Component {...pageProps} err={err} history={history} />
        <Portals />
        <Analytics />
      </IntlProviderWrapper>
    </Provider>
  );
};

export default FinaryApp;
